import { NavItem } from '../../../Common/Layout/components/Navbar/navbar.component';
import { userPermissionsEnum } from '../../../Core/Users/enums/user-permissions.enum';

export const socialNavItem: NavItem = {
    label: 'Core.navigation.social',
    permissions: [
        userPermissionsEnum.socialIntelligence
    ],
    icon: '',
    id: 'primaryNavSocial',
    items: [
        // TODO: Hidden for now as there's only Intelligence as a child route
        // {
        //     label: 'Core.navigation.social.intelligence',
        //     routerLink: '/Social/themes',
        //     id: 'primaryNavSocialIntelligence'
        // }
        {
            label: 'Core.navigation.social.socialListening',
            routerLink: '/Social',
            icon: 'fa-kit-duotone fa-agpr-social',
            id: 'primaryNavSocialListening',
            subLabel: 'Core.navigation.social.socialListening.subLabel',
        },
        {
            label: 'Core.navigation.mediaIntelligence.reports',
            icon: 'fa-kit-duotone fa-agpr-reports',
            subLabel: 'Core.navigation.mediaIntelligence.reports.subLabel',
            routerLink: '/Report/reports',
            id: 'primaryNavSocialReports',
            permissionsValidator(permissions: userPermissionsEnum[]) {
                return !permissions.includes(userPermissionsEnum.advancedMonitoring);
            },
        },
    ],
    upsellMessage: 'Core.navigation.social.unlock'
};
